import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { CultivoService } from '../cultivo.service';
import { CultivoItemViewModel, TwCultivoViewModel } from '../cultivo.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Mixin } from 'ts-mixer';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { AutorizarRecintoPIAEDCamViewModel } from '../../types/common-cam-types';

@Component({
    selector: 'app-cultivo-list',
    templateUrl: './cultivo-list.component.html',
    styleUrls: ['./cultivo-list.component.scss'],
})
export class CultivoListComponent extends Mixin(ListBase, ComponentBase) implements OnInit, OnChanges {
    @Input() dialogMode = false;
    @Input() result: CultivoItemViewModel[];
    @Input() allowToAutorizar = false;
    @Output() edit = new EventEmitter<number | null>();
    @Output() view = new EventEmitter<number | null>();
    @Output() delete = new EventEmitter<number | null>();
    @Output() baja = new EventEmitter<number | null>();
    @Output() authorize = new EventEmitter<AutorizarRecintoPIAEDCamViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    habilitarEliminar = false;
    habilitarBaja = false;
    cols: Object[];
    title = 'Listado de Cultivos';

    constructor(
        private cultivoService: CultivoService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;

        this.habilitarEliminar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ELIMINAR_CULTIVO_RECINTO).Visible;
        this.habilitarBaja = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.BAJA_CULTIVO_RECINTO).Visible;
    }

    private initCols(): void {
        const cultivoVM = proxiedPropertiesOf<CultivoItemViewModel>();

        this.cols = [
            { field: 'ExpandLink', header: '', reduce: true },
            { field: 'Link', header: '', reduce: true },
            { field: cultivoVM.Id?.toString(), header: 'Id', display: 'none' },
            { field: cultivoVM.Identificador?.toString(), header: 'Identificador' },
            { field: cultivoVM.NombreComun?.toString(), header: 'Especie' },
            { field: cultivoVM.Variedad?.toString(), header: 'Variedad' },
            { field: cultivoVM.SuperficieVariedad, header: 'Superficie Variedad (ha)' },
            { field: cultivoVM.ProduccionEstimada, header: 'Prod. estimada (kg)' },
            // { field: cultivoVM.FechaBaja, header: 'Fecha Baja' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = [...changes.result.currentValue];
            this.loading = false;
        }
    }

    onEdit(item: TwCultivoViewModel): void {
        this.edit.emit(item?.Id);
    }

    onView(item: TwCultivoViewModel): void {
        this.view.emit(item?.Id);
    }

    onDelete(item: TwCultivoViewModel): void {
        this.delete.emit(item?.Id);
    }

    onDarDeBaja(item: TwCultivoViewModel): void {
        this.baja.emit(item?.Id);
    }

    onAuthorize(item: TwCultivoViewModel, IdCampania: number): void {
        const payload = new AutorizarRecintoPIAEDCamViewModel();
        payload.Id = item.Id!;
        payload.IdCampania = IdCampania;
        this.authorize.emit(payload);
    }

    /**
     * Un cultivo estará disponible para ser dado de baja si no tiene fecha de baja.
     * Se controlará en el core, que el cultivo/recinto no esté vinculado a un periodo, con plazo activo.
     * @param item TwCultivoViewModel
     * @returns boolean
     */
    cultivoEsBaja(item: TwCultivoViewModel): boolean {
        return this.cultivoService.checkFechaBaja(item.FechaBaja) !== undefined;
    }

    showBajaBtn(item: TwCultivoViewModel): boolean {
        return this.habilitarBaja && !this.esDesautorizado(item) && !this.cultivoEsBaja(item);
    }

    showAuthorizeBtn(rowData: any): boolean {
        return this.esDesautorizado(rowData) && this.allowToAutorizar;
    }

    /**
     * Un cultivo estará en lista negra si está desautorizado para alguna campaña
     * @param item TwCultivoViewModel
     * @returns boolean
     */
    esDesautorizado(item: TwCultivoViewModel): boolean {
        return item?.CampaniasDesautorizado?.length > 0;
    }
}
